import { render } from "./QaQcFormExport.vue?vue&type=template&id=32a671d4&scoped=true"
import script from "./QaQcFormExport.vue?vue&type=script&lang=js"
export * from "./QaQcFormExport.vue?vue&type=script&lang=js"

import "./QaQcFormExport.vue?vue&type=style&index=0&id=32a671d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a671d4"]])

export default __exports__